import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { useTranslation } from 'react-i18next';
import Recapitulatif from '../../Steps/Recapitulatif';
import { buildRecapData } from '../../Settings/Utils/SharedFunctions';

const SectionParameters = ({ currentSimulationResult, exploitation, isOpen, onToggle }) => {
  const { t } = useTranslation();
  const config = currentSimulationResult.config;
  const getConstraintKey = (c) => (typeof c === 'string' ? c : (c?.name ?? Object.keys(c)[0]));
  const normalizeConstraint = (constraint) => ({
    ...constraint,
    cultures: constraint.Exploitation_Culture_Id ?? constraint.cultures ?? [],
    parcels: constraint.Parcel_Id ?? constraint.parcels ?? [],
    years: constraint.years ?? (constraint.year ? [constraint.year] : []),
  });
  const { parcelsList, culturesList, constraintsList, strategiesList, parcelConstraintsList } =
    buildRecapData({
      parcelsIds: config?.parcels,
      culturesIds: config?.cultures?.map((c) => c.id),
      cultureMinMax: Object.fromEntries(config?.cultures?.map((c) => [c.id, c.minMax]) ?? []),
      constraintsNames: config?.constraints?.map(getConstraintKey),
      constraintValues: Object.fromEntries(
        config.constraints?.map((c) => {
          const key = getConstraintKey(c);
          const value = typeof c === 'object' && c !== null ? (c[key] ?? c) : c;
          return [key, value];
        }) ?? [],
      ),
      strategies: config?.strategies,
      parcelConstraints: config?.obligationRestriction.map(normalizeConstraint),
      exploitationParcels: exploitation?.parcels,
      culturesResult: config.cultures,
      t,
    });

  return (
    <section className="section">
      <div className="section-header section-header clickable" onClick={onToggle}>
        <h2 className="section-title">{t('simulation.result.simulationParameters')}</h2>
        {isOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      </div>

      {isOpen && (
        <div className="section-collapsible">
          {currentSimulationResult?.config ? (
            <Recapitulatif
              parcelsList={parcelsList}
              culturesList={culturesList}
              constraintsList={constraintsList}
              parcelConstraintsList={parcelConstraintsList}
              strategiesList={strategiesList}
              nbYears={currentSimulationResult.config.nbYears || 4}
              title={t('simulation.result.simulationParameters')}
            />
          ) : (
            <p className="no-data">{t('simulation.result.noSimulationParameters')}</p>
          )}
        </div>
      )}
    </section>
  );
};

export default SectionParameters;
